import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { SidebarService } from 'src/app/services/sidebar.service';
import { UserService } from 'src/app/services/user.service';

import { IonIcon } from '@ionic/angular';

@Component({
    selector: 'app-hero',
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon]
})
export class HeroComponent implements OnInit {
  private userService = inject(UserService);
  private authService = inject(AuthService);
  private sidebarService = inject(SidebarService);

  img: string;
  userId: number;
  user: any;
  userHSs: any[]
  

  constructor() {
    this.getInfo();
  }

  ngOnInit() {
	this.sidebarService.refreshSidebar.subscribe(res => {
		this.getInfo();
	})
  }

  getInfo() {
    this.authService.getItemFromToken('id_user').then(async (id) => {
      this.userId = id;
      await this.userService
        .getUserPersonalInfo({ /* userID: this.userId */ })
        .then(async ({ data }: any) => {
          this.user = data;
          this.userService.getImgUser(data['personal_inf.id_uploaded_file'], this.userId).subscribe((response: any) => {
            this.img = `data:${response.contentType};base64,${response.base64}`;
          });
        });

      await this.userService
        .getUserHighSchools({ })
        .then(async ( {data} : any) => {
          this.userHSs = data;
        });
    });
  }
}
